import { ActivityDetailHeader } from "../../../../../component/molecule/ActivityDetailHeader/ActivityDetailHeader.jsx"
import { useTranslation } from "react-i18next"
import { useHtmlClassService, useSubheader } from "../../../../../_metronic/layout/index.js"
import { useDispatch, useSelector } from "react-redux"
import React, { useEffect, useState } from "react"
import { RoutesConstants } from "../../../../../constants/RoutesConstants.js"
import { Button, Card, Col, Row } from "react-bootstrap"
import { CloudDownloadOutlined } from "@material-ui/icons"
import { DATE_TYPE_ENUM, ROUTING_STATUS } from "../../../../../constants/StringConstant.js"
import { stringFormatting, findFirst, toHectare, toMeter } from "../../../../helpers/TextHelper.js"
import {
  clearDEtailDownloadSubmission,
  getDetailCertificationBlock,
  getDetailDownloadSubmission
} from "../../../../../redux/actions/SubmissionAction.jsx"
import { ICON_CONSTANTS } from "../../../../../constants/ImageConstants.js"
import { RowText, Status } from "../../../../../component/index.jsx"
import { CardBody } from "../../../../../_metronic/_partials/controls/index.js"
import { RowModule } from "../../../../../component/atoms/RowModule/RowModule.jsx"
import { timeStampToDate } from "../../../../helpers/DateHelper.js"
import { Skeleton } from "@material-ui/lab"
import BootstrapTable from "react-bootstrap-table-next"
import { ImageWithModal } from "../../../../../component/atoms/ImageWithModal/index.jsx"
import { PriviewMap } from "../../../../../component/atoms/PriviewMap/index.jsx"
import { ModalMap } from "../../../../../component/atoms/ModalMap/index.jsx"
import { ApplicationSeedCertificationFormDownload } from "../../../../../component/molecule/Print/ApplicationSeedCertificationFormDownload.jsx"
import { toast } from "react-toastify"
import SVG from "react-inlinesvg"
import { loadUserLogin } from "../../../../service/userManagementAction.js"
import { PRIVILEGE_ENUM } from "../../../../../constants/PrivilegeConstants.js"

export const DetailCertificationBlock = ({
  match: {
    params: { status, id }
  }
}) => {
  const { t } = useTranslation()
  const subHeader = useSubheader()
  const dispatch = useDispatch()
  const uiService = useHtmlClassService()
  const { Submission, General } = useSelector((state) => state)
  const [detail, setDetail] = useState({})
  const [openMap, setOpenMap] = useState(false)
  const firstIndex = 0
  const privileges = loadUserLogin().privilege
  const [createdBy, setCreatedBy] = useState(null)
  const [createdDate, setCreatedDate] = useState(null)
  const [breadcrumbsRouting, setBreadcrumbsRouting] = useState(null)
  const [breadcrumbsTittle, setBreadcrumbsTittle] = useState(null)
  const [statusStyle, setStatusStyle] = useState(null)

  useEffect(() => {
    dispatch(getDetailCertificationBlock(id))
    uiService.setExitFullPage()

    return () => {
      dispatch(clearDEtailDownloadSubmission())
    }
  }, [])

  useEffect(() => {
    if (privileges.indexOf(PRIVILEGE_ENUM.CERTIFICATION_CREATE_SUBMISSION) > -1) {
      subHeader.setButton(
        <Button
          onClick={() => {
            downloadSubmission()
          }}>
          <Row>
            <Col md={"auto"}>
              <CloudDownloadOutlined />
            </Col>
            <Col md={"auto"}>{t("label_submission_download")}</Col>
          </Row>
        </Button>
      )
    }
    subHeader.setBreadcrumbs([
      {
        pathname: RoutesConstants.SUBMISSION.LIST_SUBMISSION_BY_STATUS(
          ROUTING_STATUS.CERTIFICATION_STATUS_STRING.PENDING
        ),
        title: t("menu_submission")
      },
      {
        pathname: RoutesConstants.SUBMISSION.LIST_SUBMISSION_BY_STATUS(
          ROUTING_STATUS.CERTIFICATION_STATUS_STRING.PENDING
        ),
        title: t("menu_aside_sertification_and_block")
      },
      {
        pathname: RoutesConstants.SUBMISSION.LIST_SUBMISSION_BY_STATUS(breadcrumbsRouting),
        title: breadcrumbsTittle
      },
      {
        title: stringFormatting(detail?.header?.block_code)
      }
    ])
  }, [detail])

  useEffect(() => {
    if (Submission?.data) setDetail(Submission?.data)
  }, [Submission?.data])

  useEffect(() => {
    if (status === ROUTING_STATUS.CERTIFICATION_STATUS_STRING.SUBMITTED) {
      return (
        setCreatedBy(t("table_header_created_by")),
        setCreatedDate(t("table_header_created_date")),
        setBreadcrumbsRouting(ROUTING_STATUS.CERTIFICATION_STATUS_STRING.SUBMITTED),
        setBreadcrumbsTittle(t("label_submitted")),
        setStatusStyle(ROUTING_STATUS.STATUS_ENUM.SUBMITTED)
      )
    } else if (status === ROUTING_STATUS.CERTIFICATION_STATUS_STRING.REJECTED) {
      return (
        setCreatedBy(t("table_header_reject_by")),
        setCreatedDate(t("table_header_reject_date")),
        setBreadcrumbsRouting(ROUTING_STATUS.CERTIFICATION_STATUS_STRING.REJECTED),
        setBreadcrumbsTittle(t("label_rejected")),
        setStatusStyle(ROUTING_STATUS.STATUS_ENUM.REJECTED)
      )
    } else {
      return (
        setCreatedBy(t("table_header_received_by")),
        setCreatedDate(t("table_header_received_date")),
        setBreadcrumbsRouting(ROUTING_STATUS.CERTIFICATION_STATUS_STRING.APPROVED),
        setBreadcrumbsTittle(t("label_received")),
        setStatusStyle(ROUTING_STATUS.STATUS_ENUM.COMPLETED)
      )
    }
  }, [status])

  const columnsArea = [
    {
      dataField: "no",
      text: "No",
      headerClasses: "bg-gray"
    },
    {
      dataField: "area_code",
      text: "Nama Lahan",
      headerClasses: "bg-gray"
    },
    {
      dataField: "farmer_name",
      text: "Nama Petani",
      headerClasses: "bg-gray"
    },
    {
      dataField: "land_area",
      text: "Luas Lahan",
      headerClasses: "bg-gray"
    }
  ]

  const dataArea = detail?.area_information?.areas?.map((item, index) => {
    return {
      no: index + 1,
      area_code: stringFormatting(item.area_code),
      farmer_name: stringFormatting(item.farmer_name),
      land_area: (
        <div>
          {toMeter(stringFormatting(item.land_area_meter))} (
          {toHectare(stringFormatting(item.land_area_ha))})
        </div>
      )
    }
  })

  const noteFo = (
    <div>
      <Card className={"mb-4 p-2 bg-danger-subtle"}>
        <CardBody className={"border-bottom border-secondary border-2 py-4 w-full"}>
          <h4 className={"bold"}>{t("label_note_fo_qa")}</h4>
          <span className={"w-full"}></span>
        </CardBody>
        <CardBody>
          <div>
            {detail?.header?.note
              ? detail?.header?.note
              : t("messages_alert_note_fo", { block: detail?.header?.block_code })}
          </div>
        </CardBody>
      </Card>
    </div>
  )

  const customBottom = (
    <Card className={"mt-6"} bg={"secondary"}>
      <CardBody className={"px-12 py-4"}>
        <RowModule customColumnCss={"col-md-6"} customSeparator={"my-0"}>
          <RowText label={createdBy} value={stringFormatting(detail?.header?.submitted_by)} />
          <RowText
            label={createdDate}
            value={stringFormatting(
              timeStampToDate(detail?.header?.submitted_date, DATE_TYPE_ENUM.ISO_DATETIME_STRAP)
            )}
          />
        </RowModule>
      </CardBody>
    </Card>
  )
  const contentBottom = (
    <div className={"w-auto mr-2"}>
      <Row>
        <Col className={"mr-4"} md={"auto"}>{`Nomor : ${
          detail?.header?.request_number ? detail?.header?.request_number : "-"
        }`}</Col>
        {detail?.header?.status_enum !== ROUTING_STATUS.STATUS_ENUM.SUBMITTED ? (
          <Row>
            <Col className={"border-right border-left"} md={"auto"}>{`No. Berkas : ${
              detail?.header?.doc_number ? detail?.header?.doc_number : "-"
            }`}</Col>
            <Col md={"auto"}>{`No. Induk : ${
              detail?.header?.base_number ? detail?.header?.base_number : "-"
            }`}</Col>
          </Row>
        ) : (
          <div></div>
        )}
      </Row>
    </div>
  )
  const tittleActivity = (
    <ActivityDetailHeader
      title={detail?.header?.block_code}
      icon={ICON_CONSTANTS.ACTIVITY_ICONS.HATCHERY}
      rightContent={<Status variant={statusStyle} text={breadcrumbsTittle} />}
      bottomContent={contentBottom}
      cardBottom={customBottom}
    />
  )

  const landArea = (
    <div>
      {toMeter(stringFormatting(detail?.area_information?.land_area_meter))}&nbsp; (
      {toHectare(stringFormatting(detail?.area_information?.land_area_ha))})
    </div>
  )

  const areaInformation = (
    <Card className={"mb-4"}>
      <CardBody className={"h-auto"}>
        <h4 className={"mb-8 text-uppercase"}>
          {General.loading ? (
            <Skeleton animation="wave" variant={"text"} height={32} width={200} />
          ) : (
            t("label_area_information")
          )}
        </h4>
        <RowModule>
          <RowModule>
            <div>
              <RowText
                label={t("label_farmer")}
                value={stringFormatting(detail?.area_information?.farmer)}
              />
              <RowText
                label={t("label_mitra")}
                value={stringFormatting(detail?.area_information?.mitra)}
              />
              <RowText
                label={t("label_total_area")}
                value={stringFormatting(detail?.area_information?.total_area) + " lahan"}
              />
              <RowText label={t("label_block_area")} value={landArea} />
            </div>
          </RowModule>
          <div
            className={
              "row h-full w-full shadow-sm p-0 bg-body-tertiary rounded-lg overflow-hidden"
            }
            onClick={() => setOpenMap(true)}>
            <div className={"row mx-0 w-full h-full position-relative"}>
              {detail?.area_information?.areas?.length > 0 && (
                <PriviewMap
                  centroid={detail?.area_information?.centroid}
                  areas={detail?.area_information?.areas}
                />
              )}
            </div>
            <div className={"row row-cols-1 bottom-0 position-absolute p-6 bg-white w-full"}>
              <div className={"text-dark-50 txt-12 mb-2"}>{t("label_block_location")}</div>
              <div className={"font-weight-bolder txt-14 d-flex align-items-center text-dark"}>
                {stringFormatting(detail?.area_information?.location)}
              </div>
            </div>
          </div>
        </RowModule>
      </CardBody>
      <CardBody>
        <h4 className={"mb-6 text-uppercase"}>
          {General.loading ? (
            <Skeleton animation="wave" variant={"text"} height={32} width={200} />
          ) : (
            t("label_list_area")
          )}
        </h4>
        <div className={"border rounded table-small-padding"}>
          <BootstrapTable
            condensed
            bordered={false}
            columns={columnsArea}
            keyField={"no"}
            data={dataArea ?? []}
          />
        </div>
      </CardBody>
    </Card>
  )

  const plantInformation = (
    <Card className={"mb-4"}>
      <CardBody>
        <h4 className={"mb-6 text-uppercase"}>
          {General.loading ? (
            <Skeleton animation="wave" variant={"text"} height={32} width={200} />
          ) : (
            t("label_plant_data")
          )}
        </h4>
        <RowModule customColumnCss={"col-md-6"} customSeparator={"my-0"}>
          <RowText
            label={t("label_plant_type")}
            value={stringFormatting(detail?.plant_data?.plant_type)}
          />
          <RowText
            label={t("label_seed_class")}
            value={stringFormatting(detail?.plant_data?.seed_class)}
          />
          <RowText
            label={t("label_varietas")}
            value={stringFormatting(detail?.plant_data?.variety_name)}
          />
        </RowModule>
      </CardBody>
    </Card>
  )

  const plantingInformation = (
    <Card className={"mb-4"}>
      <CardBody>
        <h4 className={"mb-6 text-uppercase"}>
          {General.loading ? (
            <Skeleton animation="wave" variant={"text"} height={32} width={200} />
          ) : (
            t("label_planting_date_data")
          )}
        </h4>
        <RowModule customColumnCss={"col-md-6"} customSeparator={"my-0"}>
          <RowText
            label={t("label_planting_male_date")}
            value={stringFormatting(
              timeStampToDate(
                detail?.planting_date_data?.male_planting_date,
                DATE_TYPE_ENUM.ISO_DATE_ID
              )
            )}
          />
          <RowText
            label={t("label_planting_female_date")}
            value={stringFormatting(
              timeStampToDate(
                detail?.planting_date_data?.female_planting_date,
                DATE_TYPE_ENUM.ISO_DATE_ID
              )
            )}
          />
        </RowModule>
      </CardBody>
    </Card>
  )

  const lastPlantInformation = (
    <Card className={"mb-4"}>
      <CardBody>
        <h4 className={"mb-6 text-uppercase"}>
          {General.loading ? (
            <Skeleton animation="wave" variant={"text"} height={32} width={200} />
          ) : (
            t("label_data_previous_plant")
          )}
        </h4>
        <RowModule customColumnCss={"col-md-6"} customSeparator={"my-0"}>
          <RowText
            label={t("label_land_history")}
            value={stringFormatting(detail?.last_planting_data?.land_history)}
          />
          <RowText
            label={t("label_harvest_date")}
            value={stringFormatting(
              timeStampToDate(detail?.last_planting_data?.harvest_date, DATE_TYPE_ENUM.ISO_DATE_ID)
            )}
          />
          <RowText
            label={t("label_former_bero")}
            value={
              stringFormatting(detail?.last_planting_data?.bero) +
              (detail?.last_planting_data?.bero ? " Bulan" : "")
            }
          />
          <RowText
            label={t("label_disertifikasi")}
            value={
              detail?.last_planting_data?.certificate
                ? detail?.last_planting_data?.certificate
                  ? t("yes")
                  : t("no")
                : "-"
            }
          />
          <RowText
            label={t("label_plant_type")}
            value={stringFormatting(detail?.last_planting_data?.plant_type)}
          />
          <RowText
            label={t("label_seed_class")}
            value={stringFormatting(detail?.last_planting_data?.seed_class)}
          />
          <RowText
            label={t("label_varietas")}
            value={stringFormatting(detail?.last_planting_data?.variety_name)}
          />
          <RowText
            label={t("label_field_inspection")}
            value={stringFormatting(detail?.last_planting_data?.field_check)}
          />
        </RowModule>
      </CardBody>
    </Card>
  )

  const seedSourceInformation = (
    <Card className={"mb-4"}>
      <CardBody>
        <h4 className={"mb-6 text-uppercase"}>
          {General.loading ? (
            <Skeleton animation="wave" variant={"text"} height={32} width={200} />
          ) : (
            t("label_seed_source_data")
          )}
        </h4>
        <RowModule customColumnCss={"col-md-6"} customSeparator={"my-0"}>
          <RowText
            label={t("label_base_seed_source")}
            value={stringFormatting(detail?.seed_source?.seed_source_name)}
          />
          <RowText
            label={t("label_total_seed")}
            value={stringFormatting(detail?.seed_source?.seed_total) + " Kg"}
          />
          <RowText
            label={t("label_seed_class")}
            value={stringFormatting(detail?.seed_source?.seed_class)}
          />
        </RowModule>
        <Card className={"mt-6"} bg={"secondary"}>
          <CardBody className={"px-12 py-4"}>
            <h4 className={"mb-6"}>
              {General.loading ? (
                <Skeleton animation="wave" variant={"text"} height={32} width={200} />
              ) : (
                t("label_female_seed")
              )}
            </h4>
            <RowModule customColumnCss={"col-md-6"} customSeparator={"my-0"}>
              <RowText
                label={t("label_base_seed_name")}
                value={stringFormatting(detail?.seed_source?.female_seed?.base_name)}
              />
              <RowText
                label={t("label_no_lot")}
                value={stringFormatting(detail?.seed_source?.female_seed?.lot_number)}
              />
              <RowText
                label={t("label_count_seed")}
                value={stringFormatting(detail?.seed_source?.female_seed?.seed_total)}
              />
              <RowText
                label={t("label_label_number")}
                value={stringFormatting(detail?.seed_source?.female_seed?.label_number)}
              />
            </RowModule>
            <div className={"text-dark-50 txt-12 mb-2"}>Foto Label</div>
            <RowModule customColumnCss={"col-md-1 mb-2"}>
              {detail?.seed_source?.female_seed?.images.map((item, index) => {
                return (
                  <ImageWithModal
                    value={item}
                    key={index}
                    className={""}
                    titleModal={"Foto Label"}
                    imageType={"rectangle"}
                  />
                )
              })}
            </RowModule>
          </CardBody>
        </Card>
        <Card className={"mt-6"} bg={"secondary"}>
          <CardBody className={"px-12 py-4"}>
            <h4 className={"mb-6"}>
              {General.loading ? (
                <Skeleton animation="wave" variant={"text"} height={32} width={200} />
              ) : (
                t("label_male_seed")
              )}
            </h4>
            <RowModule customColumnCss={"col-md-6"} customSeparator={"my-0"}>
              <RowText
                label={t("label_base_seed_name")}
                value={stringFormatting(detail?.seed_source?.male_seed?.base_name)}
              />
              <RowText
                label={t("label_no_lot")}
                value={stringFormatting(detail?.seed_source?.male_seed?.lot_number)}
              />
              <RowText
                label={t("label_count_seed")}
                value={stringFormatting(detail?.seed_source?.male_seed?.seed_total)}
              />
              <RowText
                label={t("label_label_number")}
                value={stringFormatting(detail?.seed_source?.male_seed?.label_number)}
              />
            </RowModule>
            <div className={"text-dark-50 txt-12 mb-2"}>Foto Label</div>
            <RowModule customColumnCss={"col-md-1 mb-2"}>
              {detail?.seed_source?.male_seed?.images.map((item, index) => {
                return (
                  <ImageWithModal
                    value={item}
                    key={index}
                    className={""}
                    titleModal={"Foto Label"}
                    imageType={"rectangle"}
                  />
                )
              })}
            </RowModule>
          </CardBody>
        </Card>
      </CardBody>
    </Card>
  )

  const modalMap = (
    <ModalMap
      open={openMap}
      setOpenMap={setOpenMap}
      areas={detail?.area_information?.areas}
      centroid={detail?.area_information?.centroid}
      hideDate={true}
    />
  )

  const locationImages = (
    <Card>
      <CardBody>
        <h4 className={"mb-6 text-uppercase"}>
          {General.loading ? (
            <Skeleton animation="wave" variant={"text"} height={32} width={200} />
          ) : (
            t("label_location_image")
          )}
        </h4>

        <RowModule customColumnCss={"col-md-1 mb-2"}>
          <ImageWithModal
            value={detail?.location_images}
            className={""}
            titleModal={t("label_location_image")}
            imageType={"rectangle"}
          />
        </RowModule>
      </CardBody>
    </Card>
  )

  const downloadSubmission = () => {
    const body = {
      block_ids: [id.toString()]
    }
    dispatch(getDetailDownloadSubmission(body))
  }

  useEffect(() => {
    const prevTitle = document.title
    if (Submission?.detailDownloadSubmission?.length > 0) {
      setTimeout(() => {
        document.title = `${findFirst(Submission.detailDownloadSubmission).block_code}`
        window.print()
        setTimeout(() => {
          toast(t("messages_response_success_download_submission"), {
            position: "top-center",
            autoClose: 5000,
            className: "bg-neutral-black",
            icon: <SVG src={ICON_CONSTANTS.BULLET_TICK} />,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "dark"
          })
          dispatch(clearDEtailDownloadSubmission())
        }, 1000)
      }, 5000)
    }
    return () => {
      document.title = prevTitle
    }
  }, [Submission?.detailDownloadSubmission])

  return (
    <>
      {Submission?.detailDownloadSubmission.length > 0 && (
        <ApplicationSeedCertificationFormDownload
          data={Submission?.detailDownloadSubmission[firstIndex]}
        />
      )}
      <div className={"d-print-none"}>
        {detail?.header?.status_enum === ROUTING_STATUS.STATUS_ENUM.REJECTED && noteFo}
        {openMap && detail?.area_information?.areas?.length > 0 && modalMap}
        {tittleActivity}
        {areaInformation}
        {plantInformation}
        {plantingInformation}
        {lastPlantInformation}
        {seedSourceInformation}
        {locationImages}
      </div>
    </>
  )
}